import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { isFirstVisit, markIntroSeen } from "@/lib/intro";
import { EASE } from "@/lib/motion";

const LETTERS = "PERFERO".split("");

export const Preloader = () => {
  const [show, setShow] = useState(isFirstVisit);

  useEffect(() => {
    if (!show) return undefined;
    markIntroSeen();
    const timer = setTimeout(() => setShow(false), 1650);
    return () => clearTimeout(timer);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-navy"
          initial={{ clipPath: "inset(0% 0% 0% 0%)" }}
          exit={{ clipPath: "inset(0% 0% 100% 0%)" }}
          transition={{ duration: 0.95, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="flex overflow-hidden font-brand text-5xl tracking-[0.14em] text-ivory sm:text-7xl">
            {LETTERS.map((l, i) => (
              <motion.span key={i} initial={{ y: "110%" }} animate={{ y: "0%" }} transition={{ delay: 0.1 + i * 0.07, duration: 0.8, ease: EASE }}>
                {l}
              </motion.span>
            ))}
          </div>
          <motion.span className="mt-7 block h-px bg-copper-light" initial={{ width: 0 }} animate={{ width: 180 }} transition={{ delay: 0.55, duration: 0.9, ease: EASE }} />
          <motion.p className="mt-5 text-[13px] uppercase tracking-[0.4em] text-copper-light" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.8, duration: 0.6 }}>
            Benessere Silver Age
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
